.containerRoot {
    gap: 12px;
    height: auto;
    background-color: var(--mantine-color-gray-9);
    position: fixed;
    /* above values may not be needed */
    z-index: var(--mantine-priority-high);
    border-bottom-left-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
    margin: 0 1.0625rem 0 1.0625rem;
    padding: 0 1rem 1rem;
    width: fit-content;
    margin-left: 0;

    @media screen and (max-width: 920px) {
        width: 300px;
    }
}
